import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export class SRCheatingMainPageExThemeClickedEvent extends BaseEvent {}

export class SimpleRegistrationMainPageExThemeClickedEventHandler extends BaseEventHandler {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof SRCheatingMainPageExThemeClickedEvent;
  }

  async track() {
    return this.amplitudeService.logEvent('registration_ex_theme_screen_click');
  }
}
